import * as React from 'react';
import _ from 'lodash';
import { Paper, makeStyles, Grid, TextField, Button } from '@material-ui/core';
import { SelectWithLabel } from '../../utils/selectWithLabel';
import { useDispatch, useSelector } from 'react-redux';
import { sendItinerary } from '../../store/departures';
import { ItinStatusDisplay } from './utils/itinStatusDisplay';

let screenWidth = window.innerWidth

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: screenWidth <= 450 ? '90%' : '50%',
    // height: '25%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    // padding: theme.spacing(2, 4, 3),
  },
  sendingPaper: {
    position: 'absolute',
    width: '12%',
    height: '10%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    marginTop: '12%',
    // marginBottom: '5%',
    padding: '2px 4px 2px 4px'
  },
  errorMessage: {
    color: 'red',
    marginLeft: '10px'
  },
  ItinButton: {
    marginTop: '10px',
    marginBottom: '10px',
    height: '50%'
  }
}));

const emailIsValid = (email) => {
  // NOTE // lol, stack overflow "super simple email validation"
  // function valid_email(email) {
  //   return email.match(/^([\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*[\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+@((((([a-z0-9]{1}[a-z0-9\-]{0,62}[a-z0-9]{1})|[a-z])\.)+[a-z]{2,6})|(\d{1,3}\.){3}\d{1,3}(\:\d{1,5})?)$/i);
  // }
  let atLocation = email.indexOf('@')
  // NOTE // email must contain an @ symbol
  if (atLocation != -1) {
    // NOTE // email must have 3 characters before and after the @ symbol
    if (email.slice(0, atLocation).length >= 3 && email.slice(atLocation).length >= 3) {

      return true
    }
  }
  return false
}

// NOTE // displays the recipient choices and/or the custom choices
const RlocInputGroup = (props) => {
  let recipients = props.recipients
  let customEmail = props.customEmail
  let customRloc = props.customRloc
  let handleRecipients = props.handleRecipients
  let handleCustomEmail = props.handleCustomEmail
  let handleCustomRloc = props.handleCustomRloc
  let formattedPaxChoices = props.formattedPaxChoices
  // NOTE // the custom rloc choices are essentially the same as formattedPaxChoices aside from 'All' and 'Custom'
  let customRlocChoices = _.cloneDeep(formattedPaxChoices).map(p => {
    return {label: p.value, value: p.value}
  }).slice(2)

  if (recipients !== 'Custom') {
    return (
      <Grid container item xs={12} justify="center" style={{paddingTop: '5px', paddingBottom: '5px', borderBottom: '2px solid rgba(201, 195, 195, 1)'}}>
        {/* <Grid item xs={2}></Grid> */}
        <Grid container item lg={4} xs={12} justify="center">
          <SelectWithLabel defaultVal={recipients} handleChange={(e) => {handleRecipients(e.target.value)}} inputLabel={'Recipients'} items={formattedPaxChoices} />
        </Grid>
      </Grid>
    )
  }

  else {
    return (
      <Grid container item xs={12} justify="center" style={{paddingTop: '5px', paddingBottom: '5px', borderBottom: '2px solid rgba(201, 195, 195, 1)'}}>
        <Grid container item lg={4} xs={12} justify="center">
          <SelectWithLabel defaultVal={recipients} handleChange={(e) => {handleRecipients(e.target.value)}} inputLabel={'Recipients'} items={formattedPaxChoices} />
        </Grid>
        <Grid container item lg={4} xs={12} justify="center">
          <SelectWithLabel defaultVal={customRloc} handleChange={(e) => {handleCustomRloc(e.target.value)}} inputLabel={"Custom Rloc"} items={customRlocChoices} />
        </Grid>
        <Grid container item lg={4} xs={12} justify="center">
          <TextField label="Custom Email" value={customEmail} onChange={(e) => {handleCustomEmail(e.target.value)}} />
        </Grid>
      </Grid>
    )
  }
}

// NOTE // User error handling and display (i.e. they didn't select a recipient)
const ErrorDisplay = (props) => {
  const classes = useStyles()
  // NOTE // setting error to true makes it so they can't send the itinerary
  const setError = props.handleError
  let paxChoices = props.paxChoices
  let recipients = props.recipients
  let customEmail = props.customEmail
  let customRloc = props.customRloc

  // NOTE // if the only choices are 'Custom' and 'All', then there are no rlocs to use
  if (paxChoices.length == 2) {
    setError(true)
    return (
      <h5 className={classes.errorMessage}>There are no record locators to use for sending an itinerary</h5>
    )
  }
  // NOTE // if they choose 'Custom' for recipients
  else if (recipients == 'Custom') {
    // NOTE // they dont' have a customRloc
    if (customEmail && !customRloc) {
      setError(true)
      return (
        <h5 className={classes.errorMessage}>You need to select a record locator</h5>
      )
    }
    // NOTE // they don't have a customEmail 
    else if (!customEmail && customRloc) {
      setError(true)
      return (
        <h5 className={classes.errorMessage}>You need to enter a valid email</h5>
      )
    }
    // NOTE // they have neither a customEmail or customRloc
    else if (!customEmail && !customRloc) {
      setError(true)
      return (
        <h5 className={classes.errorMessage}>You need to select a record locator and enter a valid email</h5>
      )
    }
    // NOTE // they don't have a valid email
    else if (!emailIsValid(customEmail)) {
      setError(true)
      return (
        <h5 className={classes.errorMessage}>That email is not valid</h5>
      )
    }
  }
  // NOTE // if no error cases are hit they can send the itinerary
  setError(false)
  return (
    <div></div>
  )
}

export const ItinModal = (props) => {
  const passengers = props.paxInfo.passengers ? props.paxInfo.passengers : []
  const classes = useStyles()
  const emailStatus = useSelector(state => state.entities.departures.emailStatus)
  const sending = emailStatus !== null
  const [customEmail, setCustomEmail] = React.useState('')
  const [customRloc, setCustomRloc] = React.useState('')
  const [recipients, setRecipients] = React.useState(passengers.length ? 'All' : '')
  const [error, setError] = React.useState(false)
  const dispatch = useDispatch()

  // NOTE // formatting choices for SelectWithLabel and for the api call
  let passengerChoices = []
  let formattedPaxChoices = [{label: 'All', value: 'All'}, {label: 'Custom', value: 'Custom'}]
  if (passengers.length) {
    // passengers[i].passengerJourneyDetail.reservationStatus.cancelled
    // NOTE // value is information being sent to api/email, while label is what users see
    passengerChoices = passengers && passengers.length ? passengers.map(p => {
      return {value: p.reservation.locator || '', label: `${p.reservation.bookingInformation.contactInformation.email} (${p.reservation.locator})` || ''}
    }).filter(choice => choice.value != '') : ['']
    formattedPaxChoices = formattedPaxChoices.concat(_.uniqBy(passengerChoices, 'value'))
  }

  const handleSend = () => {
    let rlocs
    if (recipients == 'All') {
      rlocs = passengerChoices.map(p => p.value)
      if (rlocs && rlocs.length) {
        dispatch(sendItinerary(rlocs, ''))
      }
    }
    else if (recipients == 'Custom') {
      // TODO // need a customRloc and customEmail
      dispatch(sendItinerary([customRloc], customEmail))
    }
    else {
      rlocs = [recipients]
      if (rlocs && rlocs.length) {
        let email = passengers.find(p => p.reservation.locator == rlocs[0]).reservation.bookingInformation.contactInformation.email
        dispatch(sendItinerary(rlocs, email))
      }
    }
  }

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '20%'}}>
      { sending === false ?
        <Paper className={classes.paper}>
          <Grid container item xs={12} justify="center" style={{fontSize: '60px', width: '100%', height: '40%', borderBottom: '2px solid rgba(201, 195, 195, 1)', backgroundColor: 'rgb(63, 81, 181, 1)'}}>
            <h5 style={{margin: '0px', paddingTop: '12px', fontSize: '50%'}}>Send Itinerary</h5>
          </Grid>
          <RlocInputGroup recipients={recipients} customRloc={customRloc}  customEmail={customEmail} handleCustomRloc={setCustomRloc} handleRecipients={setRecipients} handleCustomEmail={setCustomEmail} formattedPaxChoices={formattedPaxChoices} />
          <Grid container item justify="center">
            <Grid item xs={12}>
              <ErrorDisplay paxChoices={formattedPaxChoices} recipients={recipients} customEmail={customEmail} customRloc={customRloc} error={error} handleError={setError} />
            </Grid>
            <Grid container item xs={12} justify="center" alignContent="center">
              {
                error ?
                <Button onClick={() => {handleSend()}} disabled variant="contained" className={classes.ItinButton} style={{backgroundColor: '#03fc66', marginRight: '8px'}}>Send</Button> :
                <Button onClick={() => {handleSend()}} variant="contained" className={classes.ItinButton} style={{backgroundColor: '#03fc66', marginRight: '8px'}}>Send</Button>
              }
              <Button variant="contained" onClick={() => {props.closeModal(false)}} className={classes.ItinButton} style={{backgroundColor: '#eb494e'}}>Close</Button>
            </Grid>
            {/* <Grid container item xs={3} justify="center" alignContent="center">
            </Grid> */}
          </Grid>
        </Paper> :
        <Paper style={{width: '40%'}}>
          <Grid container item xs={12} justify="center">
            <ItinStatusDisplay status={emailStatus} />
          </Grid>
          <Grid container item xs={12} justify="center" style={{marginBottom: '8px', marginTop: '8px'}}>
            <Button variant="contained" onClick={() => {props.closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
          </Grid>
        </Paper>
      }
    </Grid>
  )
}